<template lang="">
  <div class="apply-box" id ="apply"> 
      
      <div class="applyed"  v-if="yetapply">
        <!-- link 模式，在右侧显示链接箭头mode="link" -->
        <van-notice-bar @click ="adverInfo" left-icon="volume-o" mode="link">您已经加入过病案通，点击可查看详情</van-notice-bar>
      </div>
      
      <div class="ad">
          <div class="adverimg">
              <img src="../assets/ad1.png" alt="">
              <img src="../assets/ad2.png" alt="">
              <img src="../assets/ad3.png" alt="">
              <img src="../assets/ad4.png" alt="">
              <img src="../assets/ad5.png" alt="">
          </div>
          

          <div class="applyin" ref="refName">
              <!-- 医院名称 -->
              <div>
                  <div class="title_name" ref="ref_hosname">
                  <span >医院名称<span class="red_color">*</span><span class= "erro" v-if="hosnameErr">{{hosnamerrT}}</span></span>
                  </div>
                  <input
                      type="text"
                      placeholder="请输入"
                      class="van-field__control"
                      v-model="hosname"
                      />
                  <div class="input_line"></div>
              </div>
              <!-- 医院等级 -->
              <div>
                  <div class="title_name" ref="ref_grade">
                  <span >医院等级<span class="red_color">*</span><span class= "erro" v-if="gradeErr">{{graderrT}}</span></span>
                  </div>
                  <!-- <select class="gradec" name="" id="" v-model="gradeSelected" @change="getgradeSelected">
                      <option value="" v-for="(grade,index) in gradeList" :key="index">
                          {{grade}}
                      </option>
                  </select> -->
                  <div class="van-cell van-cell--clickable van-field">
                      
                      <div class="van-cell__value">
                          <div class="van-field__body">
                              <input
                                  type="text"
                                  placeholder="医院等级"
                                  v-model="grade"
                                  readonly="readonly"
                                  class="van-field__control"
                                  @click="getgradeSelected"
                              />
                              <div class="van-field__right-icon">
                                  <i class="van-icon van-icon-arrow">
                                  <!---->
                                  </i>
                              </div>

                          </div>
                      </div>
                      <!-- :columns="gradeList" @change="onChange" -->
                      <van-popup v-model="showgradePicker" position="bottom">
                          <van-picker
                              title = "选择医院等级"
                              show-toolbar
                              :columns="gradeList"
                              @confirm="onConfirmDep"
                              @cancel="showgradePicker = false"
                              :default-index="2"
                          />
            </van-popup>
                  </div>
                  <!-- <input
                      type="text"
                      placeholder="请选择"
                      class="van-field__control"
                      /> -->
                  <div class="input_line"></div>
              </div>
              <!-- 出院量 -->
              <div>
                  <div class="title_name" ref="ref_outhosnum">
                  <span >出院量<span class="red_color">*</span><span class="erro" v-if="outhosnumErr">{{outhosnumerrT}}</span></span>
                  </div>
                  <div class="outhosnumc">
                      <div>
                          <input
                          type="text"
                          placeholder="请选择"
                          class="van-field__control"
                          v-model="outhosnum"
                      />
                      </div>
                      <div>
                          <span class="outhosnum">人/年</span>
                      </div>
                      
                  </div>
                  
                  <div class="input_line"></div>
              </div>
              <!-- 您的姓名 -->
              <div>
                  <div class="title_name" ref="ref_applyname">
                  <span >您的姓名<span class="red_color">*</span><span class="erro" v-if="applynameErr">{{applynamerrT}}</span></span>
                  </div>
                  <input
                      type="text"
                      placeholder="请输入"
                      class="van-field__control"
                      v-model="applyname"
                      />
                  <div class="input_line"></div>
              </div>
              <!-- 您的电话 -->
              <div>
                  <div class="title_name" ref="ref_tel">
                  <span >您的手机号<span class="red_color">*</span><span class="erro" v-if="telErr">{{telrrT}}</span></span>
                  </div>
                  <!-- <input
                      type="number"
                      placeholder="请输入"
                      class="van-field__control"
                      v-model="applyphone"
                      :right-icon="alertPhoneNo"
                      color="red"
                      :rules="[{validator,message:'请输入正确的手机号'}]"
                      /> -->
                      <van-field
                        v-model="tel"
                        type="tel"
                        required
                        placeholder="请输入手机号码"
                        @input="inputPhoneNo"
                      />
                  <div class="input_line"></div>
              </div>
              <!-- 您的电话 -->
              <div>
                  <!-- <div class="title_name">
                  <span >所在城市<span class="red_color">*</span></span>
                  </div>
                  <input
                      type="text"
                      placeholder="请选择"
                      class="van-field__control"
                      />
                  <div class="input_line"></div> -->
                  <div class="title_name" ref="ref_area">
                          <span >所在城市<span class="red_color">*</span><span class="erro" v-if="areaErr">{{arearrT}}</span></span>
                  </div>
                  <div class="van-cell van-cell--clickable van-field" @click="showPopAddress">
                      
                      <div class="van-cell__value">
                          <div class="van-field__body">
                              <input
                                  type="text"
                                  placeholder="选择省 / 市 / 区"
                                  v-model="area"
                                  readonly="readonly"
                                  class="van-field__control"
                              />
                              <div class="van-field__right-icon">
                                  <i class="van-icon van-icon-arrow">
                                  <!---->
                                  </i>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="input_line"></div>
              </div>
              <!-- <div class="shengm">
                  加入即视为您已阅读并同意<span class="shengm-link">《个人信息保护声明》</span>
              </div> -->
              
          </div>
          <div class="adverimg qr_cord">
              <img src="../assets/ad6.png" alt="">
              
          </div>
          <!-- :loading="isLoading"
          loading-text="加载中..." -->
          <div 
          class="apply_button" 
          @click = "submit" 
          v-if="show_button"
          
          >
              <button>加入</button>
          </div>
      </div>
    </div>
</template>


<script>
// import Vue from "vue";
import cityList from "../utils/city.js";
import Vue from "vue";
let provinceCode, cityCode, districtCode;
import { Area, Picker, Toast, Notify, NoticeBar } from "vant";
Vue.use(Area).use(Picker).use(Toast).use(Notify).use(NoticeBar);
export default {
  name: "advertisingApply",
  data() {
    return {
      gradeList: [
        "三级甲等",
        "三级乙等",
        "三级医院",
        "二级甲等",
        "二级乙等",
        "二级医院",
        "一级甲等",
        "一级乙等",
        "一级乙等",
        "未评级",
      ],
      //   gradeList: [{index:10,name:'三级甲等'},
      //   {'index':11,'name':'三级乙等'},
      //   {'index':12,'name':'三级医院'},
      //   {'index':20,'name':'二级甲等'},
      //   {'index':21,'name':'二级乙等'},
      //   {'index':22,'name':'二级医院'},
      //   {'index':30,'name':'一级甲等'},
      //   {'index':31,'name':'一级乙等'},
      //   {'index':32,'name':'一级医院'},
      //   {index:99,name:'未评级'},],
      //   gradeSelected: "二甲",
      area: null,
      grade: null,
      showgradePicker: false,
      hosname: null,
      hosnamerrT: "",
      outhosnum: null,
      applyname: null,
      tel: null,
      gradenum: null,
      alertPhoneNo: "",
      hosnameErr: true,
      outhosnumErr: false,
      outhosnumerrT: "",
      applynameErr: false,
      applynamerrT: "",
      telErr: false,
      telrrT: "",
      gradeErr: false,
      graderrT: "",
      areaErr: false,
      arearrT: "",
      crProvice: "",
      crCity: "",
      crArea: "",
      cmsOrderId: "",
      show_button: true,
      yetapply: false,
      // isLoading:false,
    };
  },
  created() {
    console.log(this.hosname);
    console.log("this.hosname");
    let channel = localStorage.getItem("channel");
    let promoter = localStorage.getItem("promoter");
    let wxId = localStorage.getItem("wxId");
    let userId = localStorage.getItem("userId");
    console.log(userId);
    //  用户行为
    const params = {
      promoter: promoter,
      channel: channel,
      userId: userId,
      wxId: wxId,
    };
    console.log(promoter);
    console.log(channel);
    this.getrequestAd(params);
    this.getuserBehaviorlog(params);

    // 键盘弹出事件
    var clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    window.onresize = function () {
      var nowClientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (clientHeight > nowClientHeight) {
        //因为ios有自带的底部高度
        //键盘弹出的事件处理
        document.getElementById("apply").classList.add("focusState");
      } else {
        //键盘收起的事件处理
        document.getElementById("apply").classList.remove("focusState");
      }
    };

    // let wxId = localStorage.getItem("wxId");
    // this.gradeSelected = this.gradeList[0];

    // console.log(this.gradeSelected);
  },

  methods: {
    // focusInput(){
    //         document.getElementById("apply").classList.add("focusState");
    //     },

    //   blurInput(){
    //         document.getElementById("apply").classList.remove("focusState");
    //     },
    // 已注册tip点击进入详情页
    adverInfo() {
      console.log("要进入详情页");
      this.$router.push("/adverapplyafter/" + this.cmsOrderId);

      // this.$router.push({
      //       path: "/adverapplyafter",
      //       query: {
      //         cmsOrderId: this.cmsOrderId,
      //       },
      //     });
    },
    // 查询是否注册过
    getrequestAd(params) {
      this.$server.getrequestAd(params).then((res) => {
        if (res.result == 1) {
          console.log("查询是否注册过");
          console.log(res.customerInfo);
          this.cmsOrderId = res.customerInfo.cmsOrderId;
          // let userId = res.customerInfo.userId
          // this.crName = res.customerInfo.crName
          // userId = res.customerInfo.userId
          if (
            this.cmsOrderId != "" &&
            this.cmsOrderId != null &&
            this.cmsOrderId != undefined
          ) {
            console.log("该用户已申请");
            this.show_button = false;
            this.yetapply = true;
          }
        }
      });
    },
    getuserBehaviorlog(params) {
      this.$server.getuserBehaviorlog(params).then((res) => {
        // let msg = res.msg;
        if (res.result == 1) {
          console.log("调用用户行为接口成功");
          // this.lineShow = "line-show";
        }
      });
    },
    getgradeSelected() {
      console.log("换等级");
      this.showgradePicker = true;
      console.log(this.showgradePicker);
    },
    inputPhoneNo(e) {
      let rule = "^1[0-9]{10}$";
      isRegValid(this, e, rule, "alertPhoneNo");
    },
    onConfirmDep(value, index) {
      this.showgradePicker = false;
      console.log(this.showgradePicker);
      console.log(index);
      this.grade = value;
      // Toast(`当前值：${value}, 当前索引：${index}`);
      switch (value) {
        case "三级甲等":
          this.gradenum = 10;
          break;
        case "三级乙等":
          this.gradenum = 11;
          break;
        case "三级医院":
          this.gradenum = 12;
          break;
        case "二级甲等":
          this.gradenum = 20;
          break;
        case "二级乙等":
          this.gradenum = 21;
          break;
        case "二级医院":
          this.gradenum = 22;
          break;
        case "一级甲等":
          this.gradenum = 30;
          break;
        case "一级乙等":
          this.gradenum = 31;
          break;
        case "一级医院":
          this.gradenum = 32;
          break;
        case "未评级":
          this.gradenum = 99;
          break;
      }
      console.log(this.gradenum);
    },
    // onChange(picker, value, index) {
    //     console.log('选择等级了')
    //     Toast(`当前值：${value}, 当前索引：${index}`);
    // },
    validator() {
      return /^1[0-9]{10}$/.test(this.tel);
    },
    submit() {
      // 
      // this.isLoading = true
      console.log("submit");
      console.log(this.area);
      console.log(this.grade);
      console.log(this.hosname);
      console.log(this.outhosnum);
      console.log(this.applyname);
      console.log(this.tel);
      console.log(this.gradenum);
      console.log(this.crCity);
      console.log(this.crArea);
      if (
        this.hosname == "" ||
        this.hosname == null ||
        this.hosname == undefined
      ) {
        this.hosnamerrT = "医院名称不能为空";
        this.hosnameErr = true;
      } else if (/^\d+(\.\d+)?$/.test(this.hosname)) {
        this.hosnamerrT = "医院名称不能纯数字";
        this.hosnameErr = true;
      } else {
        this.hosnameErr = false;
      }
      console.log(this.hosnameErr);
      if (
        this.outhosnum == "" ||
        this.outhosnum == null ||
        this.outhosnum == undefined
      ) {
        this.outhosnumerrT = "出院量不能为空";
        this.outhosnumErr = true;
      } else if (!/^\d+(\.\d+)?$/.test(this.outhosnum)) {
        this.outhosnumerrT = "出院量只能为数字";
        this.outhosnumErr = true;
      } else if (this.outhosnum >= 1000000) {
        this.outhosnumerrT = "出院量不能大于100万";
        this.outhosnumErr = true;
      } else if (this.outhosnum <= 500) {
        this.outhosnumerrT = "出院量不能小于500";
        this.outhosnumErr = true;
      } else {
        this.outhosnumErr = false;
      }
      let regname = /^\d+(\.\d+)?$/.test(this.applyname);
      if (
        this.applyname == "" ||
        this.applyname == null ||
        this.applyname == undefined
      ) {
        this.applynamerrT = "申请者姓名不能为空";
        this.applynameErr = true;
      } else if (regname == true) {
        this.applynamerrT = "申请者姓名不能纯数字";
        this.applynameErr = true;
      } else {
        this.applynameErr = false;
      }
      let reg = /^1[0-9]{10}$/.test(this.tel);
      if (this.tel == "" || this.tel == null || this.tel == undefined) {
        this.telrrT = "手机号不能为空";
        this.telErr = true;
      } else if (reg == false) {
        this.telrrT = "请输入正确的手机号";
        this.telErr = true;
      } else {
        this.telErr = false;
      }
      if (this.grade == "" || this.grade == null || this.grade == undefined) {
        this.graderrT = "请选择医院等级";
        this.gradeErr = true;
      } else {
        this.gradeErr = false;
      }
      if (this.area == "" || this.area == null || this.area == undefined) {
        this.arearrT = "请选择所在地区";
        this.areaErr = true;
      } else {
        this.areaErr = false;
      }
      if (
        this.hosnameErr == false &&
        this.outhosnumErr == false &&
        this.applynameErr == false &&
        this.telErr == false &&
        this.gradeErr == false &&
        this.areaErr == false
      ) {
        let userId = localStorage.getItem("userId");
        let channel = localStorage.getItem("channel");
        let promoter = localStorage.getItem("promoter");
        let wxId = localStorage.getItem("wxId");

        console.log("这是userID---");
        console.log(userId);
        console.log(channel);
        if (channel == null || channel == "" || channel == undefined) {
          console.log("channel为空");
          channel = "";
          console.log(channel);
        }
        if (promoter == null || promoter == "" || promoter == undefined) {
          console.log("promoter为空");
          promoter = "";
          console.log(promoter);
        }
        console.log(promoter);
        const params = {
          crName: this.hosname,
          crClassCode: this.gradenum,
          crDischargeQuantity: this.outhosnum,
          crContactName: this.applyname,
          crContactTel: this.tel,
          crProvice: this.crProvice,
          crCity: this.crCity,
          crArea: this.crArea,
          userId: userId,
          channel: channel,
          promoter: promoter,
          wxId: wxId,
        };
        this.adregisterRequest(params);
      } else {
        if (this.hosnameErr == true) {
          this.$refs.ref_hosname.scrollIntoView();
        } else if (this.gradeErr == true) {
          this.$refs.ref_grade.scrollIntoView();
        } else if (this.outhosnumErr == true) {
          this.$refs.ref_outhosnum.scrollIntoView();
        } else if (this.applynameErr == true) {
          this.$refs.ref_applyname.scrollIntoView();
        } else if (this.telErr == true) {
          this.$refs.ref_tel.scrollIntoView();
        } else {
          this.$refs.ref_area.scrollIntoView();
        }
      }
      // this.isLoading = false
      //     let reg = /^1[0-9]{10}$/.test(this.tel);
      //     console.log(reg)
      //     if (reg == false) {
      //       Notify({
      //         type: "warning",
      //         message: "请输入正确的手机号码"
      //       });
      //     return;
      //   }
      // this.$router.push("/adverapplyafter/" + this.cmsOrderId + "/" + "1");
    },
    // 接口
    adregisterRequest(params) {
      this.$server.postrequestAd(params).then((res) => {
        // let msg = res.msg;
        if (res.result == 1) {
          console.log("调用接口成功");
          // this.lineShow = "line-show";
          this.cmsOrderId = res.cmsOrderId;
          console.log(this.cmsOrderId);
          this.$router.push("/adverapplyafter/" + this.cmsOrderId);
          // this.$router.push({
          //   path: "/adverapplyafter",
          //   query: {
          //     cmsOrderId: this.cmsOrderId,
          //   },
          // });
          // this.isShowMsg = false;
          // this.isShowCancelBtn = true;
        } else {
          // this.lineShow = "";
          // this.isShowMsg = true;
          // this.cancelMsg = res.msg;
        }
      });
    },
    /**
     * 显示地址选择器
     */

    showPopAddress() {
      // this.initAddressPicker();

      let defaultValue;
      if (provinceCode == null) {
        defaultValue = ["110000", "110000", "110101"];
      } else {
        defaultValue = [provinceCode, cityCode, districtCode];
      }
      let that = this;
      // this.show = true;
      this.$weui.picker(cityList.areaList, {
        className: "custom-classname",
        container: "body",
        depth: 3,
        defaultValue: defaultValue,
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result[0].label);
          let county = result[2] ? "/" + result[2].label : "";
          that.area = result[0].label + "/" + result[1].label + county;
          that.crProvice = result[0].label;
          that.crCity = result[1].label;
          that.crArea = result[2].label;
          console.log(that.crCity);
          console.log(that.crArea);
        },
        id: "addressPicker" + defaultValue[1],
      });
    },
    /**
     * 地址选择器确定按钮点击
     */
    confirm(e) {
      console.log(e);
      this.area = e[0].name + "/" + e[1].name + "/" + e[2].name;
      this.show = false;
    },
    /**
     * 地址选择器取消按钮点击
     */
    cancel() {
      this.show = false;
    },
  },
};
function isRegValid(that, inputValue, tmpRole, alertName) {
  console.log(alertName);
  var regName = new RegExp(tmpRole);
  console.log(regName);
  console.log(regName.test(inputValue));
  console.log(regName.exec(inputValue));
  if (regName.test(inputValue)) {
    that[alertName] = "";
    that.disabledCode = false;
  } else {
    that[alertName] = "info-o";
  }
}
</script>
<style scoped>
.focusState {
  position: absolute;
}

.ad {
  background: white;
  /* overflow-y: scroll; 
  white-space: nowrap; */
  /* position: relative; */
}
/* .van-notice-bar__right-icon{
  margin-right: 40px;
} */
.applyed {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
}
.adverimg img {
  width: 100%;
  margin: -5px 0;
}
.erro {
  color: red;
  font-size: 14px;
  margin-left: 10px;
}
.applyin {
  background: white;
  /* width: 100%; */
  padding: 20px 30px;
  margin-top: -2px;
  /* margin-bottom: 15px; */
}
.title_name {
  color: #333;
  font-size: 16px;
}
/* #outhosnum{
    display: none;
} */
.red_color {
  color: red;
}
.inputIn {
  /* border: none; */
  width: 70%;
}
.input_line {
  border-bottom: 1px solid #dddddd;
  width: 100%;
  margin-bottom: 30px;
}
.van-field__control {
  margin: 8px 0 4px 0;
  background-color: none;
  /* width: 70%; */
}
.van-cell--required::before {
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: "*";
  display: none;
}
.gradec {
  width: 100%;
  border: none;
  height: 40px;
  font-size: 16px;
}
.outhosnumc {
  display: flex;
  justify-content: space-between;
}
.outhosnum {
  flex: 2;
}
.shengm {
  color: #999999;
  font-size: 14px;
  /* margin-top: -12px; */
}
.shengm-link {
  color: #268aff;
}
.qr_cord {
  margin-top: 20px;
  padding-bottom: 100px;
}
.apply_button {
  width: 100%;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 20px;
  background: #268aff;
  line-height: 52px;
  position: fixed;
  bottom: 0;
}
.van-cell {
  padding: 10px 0;
}
.fixed-box {
  position: fixed;
  left: 5px;
  bottom: 6rem;
  width: 2rem;
  height: 2.5rem;
}
</style>